import React, { useEffect } from "react";
import { AiOutlineCloudDownload } from "react-icons/ai";
import "../App.css";
import AOS from "aos";
import "aos/dist/aos.css";


const About = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  });

  return (
    <div
      name="about"
      className="w-full h-auto bg-gradient-to-b from-gray-800 to-black text-white"
    >
    
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-auto">
        <div className="pb-8">
          <h2 className="text-4xl  font-bold inline border-b-4 border-gray-500">
            About
          </h2>
        </div>

        <p
          data-aos="slide-up"
          data-aos-duration="500"
          className="text-xl mt-5 ease-in fade-in"
        >
          I embarked my journey as a B.Tech Computer Science & Engineering
          student at{" "}
          <span
            data-aos="fade-left"
            data-aos-easing="ease-in-sine"
            data-aos-duration="1000"
            className="animate-text bg-gradient-to-r from-orange-500 to-teal-500   via-purple-500 bg-clip-text text-transparent font-black"
          >
            GLA University, Mathura
          </span>{" "}
          in 2020. Along the way, I fearlessly explored various fields,
          including Graphic Designing, Web Developement, Coding. I delved into
          the world of cutting-edge technologies, such as Java, Figma(UI&UX),
          ReactJS, NextJS, MongoDB, and NodeJS. I am a diligent and adaptable
          individual with a strong commitment to punctuality. I thrive on
          embracing new challenges and staying updated with the latest
          technologies.
        </p>
        <br />
        <p
          data-aos="slide-up"
          data-aos-duration="500"
          className="text-xl mt-5 ease-in fade-in"
        >
          
          I have set two distinct goals for my career – a short-term goal and a
          long-term goal. In the short term, I aspire to become a proficient
          software developer. Looking ahead, my long-term goal is to envision
          myself in a leadership role, such as a project manager, or attaining a
          higher position in the field of software development. My ultimate aim
          is to be a successful and accomplished professional in the software
          development industry within the next five years.
        </p>
      
        <div
          data-aos="zoom-in"
          data-aos-duration="500"
          className="mb-20 fade-in flex mx-auto items-center justify-center hover:scale-105 duration-300 rounded bg-gradient-to-b from-cyan-500 to-blue-500 lg:w-1/5 md:w-1/5 w-2/4 h-10 text-center cursor-pointer mt-10 gap-2"
        >
          <AiOutlineCloudDownload />
          <a to="https://github.com/arpiiit/Download-CV/blob/main/Arpit%20Mishra%20ResumeGLA%20web.pdf" download>
            Download CV
          </a>
        </div>
      </div>
    </div>
  );
};

export default About;
